export default "__VITE_ASSET__c92931b9__"